export default $(document).ready(e => {

    $(function () {
        $(".btn-delete-file").click(function () {
            let id = $(this).data("file_id");
            $("#confirmDeleteModal").modal("show");
        });
    });

    // listener for click on delete button inside of modal
    $(function () {
        $("#confirmDeleteModal").on("show.bs.modal", function (event) {
            const button = event.relatedTarget;
            let id = button.getAttribute("data-bs-file_id");
            let modal = $(this);
            modal.find("#btn-modal-delete-file").data("file_id", id);
        });
    });

    // Delete file on confirm button click in modal
    $(function () {
        $("#btn-modal-delete-file").click(function (event) {
            event.preventDefault();

            let id = $(this).data("file_id");

            $.ajax({
                url: "/filemanager/delete/" + id,
                type: "DELETE",
                success: function (result) {
                    $("#confirmDeleteModal").modal('hide');
                    $("#file_" + id).remove();
                }
            });
        });
    });
});
